import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckSmall = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "m400-410.891 240.174-240.174q12.913-12.913 29.326-12.913t29.326 12.913 12.913 29.445-12.913 29.446l-269.761 270Q416.391-309.5 399.5-309.5t-29.565-12.674l-109-109q-12.913-12.913-12.794-29.446.12-16.532 13.033-29.445t29.446-12.913q16.532 0 29.445 12.913z" })));
const ForwardRef = forwardRef(SvgCheckSmall);
const Memo = memo(ForwardRef);
export default Memo;
